import request from '@/utils/request';

export async function selBusinessDataSum(params) {
  return request.post('/api/stat/statBusiness/selBusinessDataSum', { ...params });
}

export async function selBusinessTypeDataCount(params) {
  return request.post('/api/stat/statBusiness/selBusinessTypeDataCount', { ...params });
}

export async function selBusinessSalesTopDataCount(params) {
  return request.post('/api/stat/statBusiness/selBusinessSalesTopDataCount', { ...params });
}

export async function selBusinessUpTrendDataList(params) {
  return request.post('/api/stat/statBusiness/selBusinessUpTrendDataList', { ...params });
}

export async function selBusinessTypeUpTrendDataList(params) {
  return request.post('/api/stat/statBusiness/selBusinessTypeUpTrendDataList', { ...params });
}
export async function selBusinessShopLocalByParam(params) {
  return request.post('/api/stat/statBusiness/selBusinessShopLocalByParam', { ...params });
}


